import Vue from 'vue'
import withRender from './button.html'
import './button.scss'

const VALID_TYPES = [
  'primary', 'secondary', 'tertiary', 'icon', 'link', 'compact-text', 'chip', 'toggle', 'toolbar'
]

// no border or background buttons
const FLAT_TYPES = ['icon', 'link', 'compact-text', 'toolbar']

export default withRender(Vue.extend({
  data() {
    return { iconPosition: null }
  },
  props: {
    disabled: Boolean,
    disabledClassOnly: Boolean,
    // set to true to have an icon only button (no text), have even padding applied
    type: {
      type: String,
      default: 'primary',
      validator: value => VALID_TYPES.indexOf(value) > -1
    }
  },
  computed: {
    classes() {
      const btnClasses = [
        'tt-o-button', `tt-o-button--${this.type}`
      ]
      if (this.iconPosition) {
        const typeQualifier = this.isFlat ? 'flat-' : (this.type === 'chip' ? 'chip-' : '')
        btnClasses.push(`tt-o-button--${typeQualifier}icon-${this.iconPosition}`)
      }
      if (this.disabled || this.disabledClassOnly) {
        btnClasses.push('tt-o-button--disabled')
      }
      return btnClasses
    },
    isFlat() {
      return FLAT_TYPES.indexOf(this.type) > -1
    }
  },
  methods: {
    isNodeIcon(node) {
      return node.tag && node.tag.indexOf('icon') > -1
    }
  },
  created() {
    // NOTE: this counts on the contents of the button being set ahead of time.  If the contents
    // of the button are dynamic (changes what is included in the slot), then it may not render
    // as desired.  If this becomes a problem, possible options is to change the computed 'classes'
    // function to change to a method so it is called on every redraw.  Think that would work, it
    // is just less efficient.
    const slotNodes = this.$slots.default
    if (slotNodes) {
      if (this.type !== 'icon' && slotNodes.length > 1) {
        if (this.isNodeIcon(slotNodes[0])) {
          // icon left
          this.iconPosition = 'left'
        } else if (this.isNodeIcon(slotNodes[slotNodes.length - 1])) {
          // icon right
          this.iconPosition = 'right'
        }
      }
    }
  }
}))
